namespace Ir.Components.PDFTemplate.SelectPDFTemplate {

    interface ISelectPDFTemplateViewModel {
        selectBoxOptions: DevExpress.ui.dxSelectBox.Properties;
        selectComponent: DevExpress.ui.dxSelectBox;

        checkBoxOptions: DevExpress.ui.dxCheckBox.Properties;
        checkBoxComponent: DevExpress.ui.dxCheckBox;

        pdfTemplates: Array<PdfTemplate>;
    }
    interface ISelectPDFTemplateParams {
        callback: (obj) => boolean;
    }

    export function getViewModel(this: ISelectPDFTemplateViewModel, params: ISelectPDFTemplateParams) {
        this.pdfTemplates = PDFTemplatesService.getPDFTemplates(false, workbook.workbookConfig.mappingId, true);

        this.checkBoxOptions = {
            value: false,
            text: 'Landscape',
            onInitialized(e) {
                this.checkBoxComponent = e.component;
            }
        };

        this.selectBoxOptions = {
            dataSource: this.pdfTemplates,
            displayExpr: 'name',
            valueExpr: 'id',
            width: 240,
            onInitialized(e) {
                this.selectComponent = e.component;
            }
        }

        params.callback({
            confirm: function (this: ISelectPDFTemplateViewModel) {
                const pdfTemplateId = this.selectComponent.option("value");
                const landscape = this.checkBoxComponent.option("value");
                return { pdfTemplateId: pdfTemplateId, landscape: landscape };
            }.bind(this)
        });
    }
}